export const handleScroll = (top = 0, left = 0) => {
  if (window !== undefined) {
    window.scrollTo({
      top,
      left,
    })
  }
}
